import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CustomBrandDataState from "@tCentro/Store/Reducer/CustomBrandDataState";
import { Draft } from "immer";
import { BrandCategoryModel } from "@insite/client-framework/Types/ApiModels";


const initialState: CustomBrandDataState = {
    isloading: false,
    brandId: "all_brands",
    brandCategoriesData: []
};

const reducer = {
    "Custom/Brand/setInitialValue": (draft: Draft<CustomBrandDataState>) => {
        draft.isloading = false;
        draft.brandId = "all_brands";
        draft.brandCategoriesData = [];
    },
    "Custom/Brand/Loading": (draft: Draft<CustomBrandDataState>, action: { data: boolean }) => {
        draft.isloading = action.data;
    },

    "Custom/Brand/BrandFilterId": (draft: Draft<CustomBrandDataState>, action: { data: string }) => {
        draft.brandId = action.data;
    },
    "Custom/Brand/BrandCategoriesData": (draft: Draft<CustomBrandDataState>, action: { data: BrandCategoryModel[] }) => {
        draft.brandCategoriesData = action.data;
        draft.isloading = false;
    }
};

export default createTypedReducerWithImmer(initialState, reducer);
